angular.module('aq.filters.transformers')
.filter("darkColor", ['aqColors', function(aqColors) {
    return function(input) {
        return aqColors.colorLuminance(aqColors.getUniqueColorFromName(input), -0.5);
    }
}]);